import BasePage from "pages/base_page"

export default class InfoPage extends BasePage {
  initialize(options) {
    super.initialize(options)
  }
}
